import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout, LoginLayout } from "./layouts";

// Route Views
import Dashbord from "./views/Dashbord";
import AddFormData from "./views/AddFormData";
import ListDatas from "./views/listFormData";
import PatientData from "./views/PatientData";
import AddUser from "./views/AddUser";
import ListUser from "./views/listUsers";
import UserData from "./views/UserData";
import AdminData from "./views/AdminData";
import Logout from "./views/Logout";
import Incomplet from "./views/listIncomp";
import FollowUp from "./views/AddFollow";
import Finished from "./views/finishedList";
import FollowView from "./views/ViewFollow";

export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/dashbord" />
  },
  {
    path: "/dashbord",
    layout: DefaultLayout,
    component: Dashbord
  },
  {
    path: "/add-formdata",
    layout: DefaultLayout,
    component: AddFormData
  },
  {
    path: "/list-formdata",
    layout: DefaultLayout,
    component: ListDatas
  },
  {
    path: "/incomplete",
    layout: DefaultLayout,
    component: Incomplet
  },
  {
    path: "/patientdata/:id",
    layout: DefaultLayout,
    component: PatientData
  },
  {
    path: "/finished",
    layout: DefaultLayout,
    component: Finished
  },
  {
    path: "/followview/:id",
    layout: DefaultLayout,
    component: FollowView
  },
  {
    path: "/add-user",
    layout: DefaultLayout,
    component: AddUser
  },
  {
    path: "/list-user",
    layout: DefaultLayout,
    component: ListUser
  },
  {
    path: "/userdata/:id",
    layout: DefaultLayout,
    component: UserData
  },
  {
    path: "/admin-profile",
    layout: DefaultLayout,
    component: AdminData
  },
  {
    path: "/follow/:id",
    layout: DefaultLayout,
    component: FollowUp
  },

  {
    path: "/logout",
    layout: LoginLayout,
    component: Logout
  },

  {
    path: "/login",
    layout: LoginLayout,
    component: () => <Redirect to="/dashbord" />
  }
];
